import React, { useState, useEffect, useContext } from "react";
import Layout from "../../components/Layout/Layout";
import { db } from "../../firebase/firebase-config";
import { useAuthState } from 'react-firebase-hooks/auth';
import { collection, query, where, getDocs, getDoc, deleteDoc, doc } from "firebase/firestore";
import { Table, Input, Select } from 'antd';
import { auth } from '../../firebase/firebase-config';
import BeatLoader from "react-spinners/BeatLoader";
import AddFacilityServiceModal from "./AddFacilityTypeModal/AddFacilityTypeModal";
import "tippy.js/dist/tippy.css";
import { ConfirmModal } from "../../components";
import DataTable from "./table/DataTable";
import { deleteFacilityType, getAllFacilityTypes } from "../../services/facilities";
import { toast } from "react-toastify";

const { Search } = Input;


const override = {
  marginTop: "20px",
};


function Index() {
  const [allFacilityTypesData, setAllFacilityTypesData] = useState<any[]>([]);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [editData, setEditData] = useState(null);

  const [searchText, setSearchText] = useState<string>('');
  const [filteredData, setFilteredData] = useState<any[]>(allFacilityTypesData);

  const [showConfirmodal, setShowConfirmModal] = useState(false);
  const [currentActiveId, setCurrentActiveId] = useState();

  const [user] = useAuthState(auth);


  const [loading, setLoading] = useState(false);

  const deleteType = async () => {
    console.log('Delete Facility Type')
      // LOGIC TO DELETE SPECIALITY

      try {
        if(currentActiveId) {
          await deleteFacilityType(currentActiveId);
          toast.success('Type Deleted successfully');
          fetchData();
        }
      } catch (error) {
        toast.error('Error deleting Type');
      }finally{
        setShowConfirmModal(false);
      }
  }

  const toggleAddModal = () => {
    setShowCreateModal(!showCreateModal);
  };


  const fetchData = async () => {
    setLoading(true);

    getAllFacilityTypes().then((res: any) => {
        console.log('RESPONSE: ', res);
        // setAllLogsData(res.data?.data)
        setAllFacilityTypesData(res?.data?.data)
        setLoading(false);
      })

    setLoading(false);
  };


  const handleEdit = (facilityData: any) => {
    setEditData(facilityData);
    setShowCreateModal(true);
  };


  useEffect(() => {
    // console.log('FETCHING: ......')
    fetchData();
  }, []);

  const [sortedInfo, setSortedInfo] = useState<any>({});

  const handleChange = (pagination: any, filters: any, sorter: any) => {
    setSortedInfo(sorter);
  };

  allFacilityTypesData.forEach((item: any, index: any) => {
    item.index = index + 1;
  });

  useEffect(() => {
    let fillData = filterData(allFacilityTypesData, searchText);
    setFilteredData(fillData);

  }, [allFacilityTypesData, searchText]);

  const filterData = (data: any[], query: string) => {
    if (!query) return data;

    return data.filter((item) =>
      Object.values(item).some((value: any) =>
        value?.toString().toLowerCase().includes(query.toLowerCase())
      )
    );
  };


  const handleSearch = (value: string) => {
    setSearchText(value);
  };


  return (
    <>
    <Layout title="Types" pageTitle="All  Facility Types">
      <div className="section">
        <div className="parent-con">
          <div className="data-table">
            <div className="top">
              <div className="span">
                <h3>All Facility Types</h3>
              </div>

              <button 
               onClick={toggleAddModal}
              className="btn btn-primary btn-add student-button">
                New Facility Type
              </button>
            </div>
            <div className="table-con">
                <div style={{ textAlign: "center" }}>
                  <BeatLoader
                    color="#3080ED"
                    loading={loading}
                    cssOverride={override}
                  />
                </div>
                <Search
                  placeholder="Search for data..."
                  onSearch={handleSearch}
                  onChange={(e) => handleSearch(e.target.value)}
                  value={searchText}
                  style={{ width: 200, marginBottom: 16 }}
                />

                    <DataTable key={allFacilityTypesData.length}
                    onEdit={handleEdit} onDelete={(record: any) => {
                      console.log('RECORD: ', record)
                      setCurrentActiveId(record?.id);
                      setShowConfirmModal(true)
                    }}
                     data={filteredData} />
              
              </div>
  
          </div>
        </div>
      </div>
    </Layout>

    {showCreateModal && <AddFacilityServiceModal editData={editData} onClose={() => {
      setShowCreateModal(false)
      setEditData(null)
    }}  onContentAdded={() => {
        setEditData(null)
        setShowCreateModal(false);
        fetchData();
    }} />}
    {showConfirmodal && (
          <ConfirmModal 
              title="Delete Faciliy Type"
              message="Are you sure you want to delete facility type ?"
              onAccept={() => deleteType()}
              onCancel={() => setShowConfirmModal(false)}
          />
      )}
    </>
  );
}

export default Index;
